import { html } from "lit"
import "@luminecence/composants/LibelleChamp"
import PopupBase from "@luminecence/composants/PopupBase"

export const EVENEMENT_CHANGEMENT_PROFIL = "evenementChangementProfil"

export default class PopupMonProfil extends PopupBase {
  static properties = { pseudo: { type: String }, erreur: { type: String } }
  static styles = PopupBase.styles

  constructor() {
    super()
    this.pseudo = ""
    this.erreur = ""
  }

  render() {
    return html`
        <div class="conteneur">
            <h1>Mon profil</h1>
            ${this.genererTemplateErreur()}
            <div class="formulaire">
              <p-libelle-champ libelle="pseudo" type="text" id-input="pseudo" .valeur=${this.pseudo} @evenementChangerValeurChamp=${this.changerPseudo}></p-libelle-champ>
            </div>
        </div>
        ${this.renderBoutons()}
        `
  }

  genererTemplateErreur() {
    return this.erreur ? html`<span class="erreur">${this.erreur}</span>` : ""
  }

  formulaireValide() {
    if (!this.pseudo.trim()) {
      this.erreur = "Le pseudo ne peut pas être vide."
      return false
    }

    this.erreur = ""
    return true
  }

  valider() {
    if (!this.formulaireValide()) {
      return
    }
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: { pseudo: this.pseudo },
      }),
    )
    this.fermerPopup()
  }

  annuler() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    )
    this.fermerPopup()
  }

  changerPseudo(event) {
    this.pseudo = event.detail?.valeur ?? event.target.value
  }
}
customElements.define("p-popup-mon-profil", PopupMonProfil)
